import React from "react";
import Select, {components} from "react-select";
import {optionItemFinder} from "../../helpers/OptionHelper";
import useIsMobile from "../../helpers/MobileHelper";
import _ from 'lodash';
import {useSelector} from "react-redux";

function SelectField({
                         input,
                         options,
                         classNamePrefix,
                         className,
                         isSearchable,
                         disableDefaultFilter,
                         onInputChange,
                         menuIsOpen,
                         menuPlacement,
                         onMenuClose,
                         onFocus,
                         onBlur,
                         onClick,
                         styles,
                         currentWidth,
                         meta: {touched, error, submitError}
                     }) {
    const onChange = option => input.onChange(option.value);
    const value = () => optionItemFinder(input.value, options);
    const filterOption = disableDefaultFilter ? {filterOption: () => true, onInputChange: onInputChange} : {};
    let hasError = touched && (error || submitError);
    const isMobile = useIsMobile();

    isSearchable = !!isSearchable;

    className = className || '';
    className = isSearchable === true ? className+' select-searchable' : className;
    className = hasError ? className+' has-error' : className;

    const {user} = useSelector(state => state.user);
    const isNightMode = !_.isEmpty(user) ? user?.preferences?.night_mode : '';

    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            borderColor: hasError ? '#FF5252 !important' : provided.borderColor,
        }),
        input: (provided) => ({
            ...provided,
            color: isNightMode ? "white" : "hsl(0,0%,20%)",
        }),
    };

    const truncateText = (text, maxLength, currentWidth) => {
        if (currentWidth > 767 || text.length <= maxLength) {
            return text;
        }

        // Find the last space within the maximum length
        const lastSpaceIndex = text.lastIndexOf(' ', maxLength);

        // Find the position of the opening and closing parentheses
        const openingParenIndex = text.indexOf('(');
        const closingParenIndex = text.indexOf(')');

        // Check if the last space is inside the parentheses
        if (openingParenIndex !== -1 && closingParenIndex !== -1 && lastSpaceIndex > openingParenIndex && lastSpaceIndex < closingParenIndex) {
            // Find the last comma inside the parentheses
            const lastCommaIndex = text.lastIndexOf(',', closingParenIndex);
            if (lastCommaIndex !== -1) {
                // Truncate at the last comma inside the parentheses
                return text.substring(0, lastCommaIndex) + '...)';
            }
        }

        // Truncate at the last space before the maximum length and add '...'
        return text.substring(0, lastSpaceIndex) + '...';
    };


    const DropdownIndicator = (props) => {
        return (
            <components.DropdownIndicator {...props}>
                {' '}
            </components.DropdownIndicator>
        );
    };

    const Option = (props) => {
        const iconClassName = props.selectProps.classNamePrefix+'__icon';
        const labelClassName = props.selectProps.classNamePrefix+'__label';
        const imageClassName = props.selectProps.classNamePrefix+'__image';

        return <components.Option {...props}>
            { props.data.icon && <span className={iconClassName}><img src={props.data.icon} alt="icon" /></span> }
            { props.data.labelName && <span className={labelClassName}>{props.data.labelName}</span> }
            <span>{truncateText(props.label, 37, currentWidth)}</span>
            { props.data.image && <img src={props.data.image} className={imageClassName} /> }
        </components.Option>
    };

    const SingleValue = ({data, selectProps: {classNamePrefix}}) => (
        <div className={classNamePrefix+'__single-value'}>
            { data.icon && <span className={classNamePrefix+'__icon'}><img src={data.icon} alt="icon" /></span> }
            <span>{truncateText(data.label, 37, currentWidth)}</span>
        </div>
    );

    return <Select
        {...input}
        value={value()}
        onChange={onChange}
        options={options}
        className={className}
        classNamePrefix={classNamePrefix || 'select'}
        components={{DropdownIndicator, Option, SingleValue}}
        menuIsOpen={menuIsOpen}
        onMenuClose={onMenuClose}
        menuPlacement={menuPlacement}
        onFocus={onFocus}
        onBlur={onBlur}
        onClick={onClick}
        isSearchable={isSearchable}
        currentWidth={currentWidth}
        isOptionDisabled={option => option.disabled}
        placeholder={isMobile ? 'Select' : 'Select ...'}
        styles={{ ...styles, ...customStyles }}
        {...filterOption}
    />
}

export default SelectField;
